import { render } from "./PythonView.vue?vue&type=template&id=cb7635a8&scoped=true"
import script from "./PythonView.vue?vue&type=script&lang=js"
export * from "./PythonView.vue?vue&type=script&lang=js"

import "./PythonView.vue?vue&type=style&index=0&id=cb7635a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb7635a8"]])

export default __exports__